/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { loginApi } from '../../setup/setupApi';
import { UserAttributeRequest, UserAttributes } from './types';

// Attributes schema requests

export const getAttributesSchema = (projectId: string): Promise<Record<string, unknown>> =>
  loginApi.get(`project/${projectId}/attribute_schema`).then((res) => res.data);

export const putAttributesSchema = (projectId: string, values: Record<string, unknown>) =>
  loginApi.put(`project/${projectId}/attribute_schema`, values).then((res) => res.data);

export const deleteAttributesSchema = (projectId: string) =>
  loginApi.delete(`project/${projectId}/attribute_schema`);

// Attributes user requests

export const getUserAttributes = (projectId: string, userId: string): Promise<UserAttributes> =>
  loginApi.get(`projects/${projectId}/users/${userId}/attributes`).then((res) => res.data);

export const postUserAttribute = (userId: string, values: UserAttributeRequest) =>
  loginApi.post(`/attributes/users/${userId}/update`, values).then((res) => res.data);

export const postUserReadonlyAttribute = (userId: string, values: UserAttributeRequest) =>
  loginApi.post(`/attributes/users/${userId}/update_read_only`, values).then((res) => res.data);
